import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { AddCustomerFromBranchComponent }            from './customer.add-from-branch.component';
import { CustomerBranchHistoryComponent }            from './customer.branch-history.component';
import { CustomerActivityLogsComponent }             from './customer.activity-logs.component';
import { CustomerChangeComponent }                   from './customer-change.component';
import { CustomerComponent }                         from './customer.component';
import { CustomerResolveMatchesComponent }           from './customer-resolve-matches.component';
import { CustomerSendPortalInvitationComponent }     from './customer-send-portal-invitation.component';
import { CustomerStatementSettingsComponent }        from './customer-statement-settings.component';
import { CustomersListComponent }                    from './customers.list.component';
import { CustomerTypePipe }                          from './customer.type.pipe';
import { CustomersModule as AppCustomersModule } from '../../app/customers/customers.module';
import { SharedModule }                   from '../shared/shared.module';
import { TableModule }                    from '../table/table.module';

@NgModule({
  declarations: [
    AddCustomerFromBranchComponent,
    CustomerBranchHistoryComponent,
    CustomerActivityLogsComponent,
    CustomerChangeComponent,
    CustomerComponent,
    CustomerResolveMatchesComponent,
    CustomerSendPortalInvitationComponent,
    CustomerStatementSettingsComponent,
    CustomersListComponent,
    CustomerTypePipe
  ],
  entryComponents: [
    AddCustomerFromBranchComponent,
    CustomerBranchHistoryComponent,
    CustomerActivityLogsComponent,
    CustomerChangeComponent,
    CustomerComponent,
    CustomerResolveMatchesComponent,
    CustomerSendPortalInvitationComponent,
    CustomerStatementSettingsComponent,
    CustomersListComponent
  ],
  exports: [
    CustomerTypePipe,
    CustomersListComponent,
  ],
  imports: [
    AppCustomersModule,
    SharedModule,
    TableModule
  ],
  providers: [
    CustomerTypePipe,
    {
      provide : 'customerType',
      useClass: CustomerTypePipe
    }
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class CustomersModule {}
